<template>
  <div>
    <div class="publicMessage">
        <div class="noticeBox">
            <img src="/static/home/laba.webp" style="width: 18px;height: 18px;" alt="" srcset=""> 直播公告：
        </div>
        <div class="gundong">
           <Scroller :lists="notice" class="scrollContainer"></Scroller>
        </div>
    </div>
  </div>
</template>

<script>
  import Scroller from './lz_notice.vue'
  export default {
    components:{
      Scroller
    },
    props:{
      notice:{
        type:Array,
        default:()=>{
          return []
        }
      }
    },
    data() {
      return {
        list:[]
      }
    },
  }
</script>

<style lang="scss" scoped>
  .publicMessage{
    display: flex;
    align-items: center;
    padding: 0 12px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #2C62CF;
    padding-bottom: 12px;
    margin-bottom:6px;
    border-bottom: 1px solid #EBEEF3;
    .gundong{

    }
    .noticeBox{
      display: flex;
      min-width: 99px;
    }
    .scrollContainer {
        color: #ffffff;
        font-size: 16px;
        width: 100%;
        height: 30px;
        line-height: 30px;
        overflow: hidden;
    }
    img{
      margin-right: 8px;
    }
    span{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #787B96;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/components/lz_noticeItem.vue